import { render, staticRenderFns } from "./University.vue?vue&type=template&id=9d0e899c&lang=html"
import script from "./University.vue?vue&type=script&lang=js"
export * from "./University.vue?vue&type=script&lang=js"
import style0 from "./University.vue?vue&type=style&index=0&id=9d0e899c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports